import React, { useEffect, useState } from 'react';
import PageHeader from '../../PageHeader/PageHeader';
import { HitApi } from '../../Api/ApiHit';
import { searchBilling } from '../../constant/Constant';
import { useSelector, useDispatch } from 'react-redux';
import { setApiJson } from '../../redux/Actions/ApiAction';
import { getSelectedUnit } from '../../storage/Storage';
import { Armchair, BookTemplate, Calendar, ContactRound, EllipsisVertical, Eye, IndianRupee, ReceiptIndianRupee, User } from 'lucide-react';
import AppTable from '../../components/AppTable/AppTable';
import { useNavigate } from 'react-router-dom';
import AppButton from '../../components/AppButton/AppButton';
import { setMemberShipJson, setPackageJson, setProductJson, setServicesJson } from '../../redux/Actions/BillingAction';
import { setPagination } from '../../redux/Actions/TableAction';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import { SET_BILLING__DATA } from '../../redux/ActionName/ActionName';
import BillPreviewModal from './GenerateBill';

function BillingSearch() {
    const BillingReducer = useSelector((state) => state.BillingReducer);
    const TableDataReducer = useSelector((state) => state.TableReducer);
    const dispatch = useDispatch();
    const getUnit = getSelectedUnit();
    const navigate = useNavigate();
    const [tab, setTab] = useState("Pending")
    const [showPreview, setShowPreview] = useState(false)
    const [billIndex, setBillIndex] = useState(null)

    useEffect(() => {
        if (BillingReducer?.billingData === null) {
            loadPendingBilling();
        }
    }, [TableDataReducer.pagination.page, TableDataReducer.pagination.limit, tab]);

    const loadPendingBilling = () => {
        const json = {
            page: 1,
            limit: 20,
            search: {
                unitIds: getUnit?._id,
                billingStatus: tab === 'Pending' ? false : true,
            },
        };
        HitApi(json, searchBilling).then((res) => {
            if (res?.message === 'Billing records retrieved successfully' && res?.data) {
                console.log('Billing data:-----', res?.data);
                dispatch(setDataAction(res?.data, SET_BILLING__DATA));
            }
        })
            .catch((error) => {
                console.error('Error fetching billing data:', error);
                dispatch(setApiJson({}));
            });
    };
    const handleCardClick = (record) => {
        navigate(`/quicksale/add/${record._id}`)


    };
    const showService = (row) => {
        console.log("row------", row);
    }
    const onClickQuickSell = (path) => {
        dispatch(setServicesJson([]));
        dispatch(setProductJson([]));
        dispatch(setMemberShipJson([]));
        dispatch(setPackageJson([]));
        navigate(path)
    }
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            });
        } catch (error) {
            return 'Invalid Date';
        }
    };
    const tableHeaders = [
        {
            title: "Client Name",
            key: "clientName",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                        <User size={16} />
                    </div>
                    <span className="font-medium text-gray-900">
                        {row.clientInfo?.name || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Contact",
            key: "phoneNumber",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                        <ContactRound size={16} />
                    </div>
                    <span className="font-medium text-gray-900">
                        {row.clientInfo?.phoneNumber || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Bill no.",
            key: "billNo",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                        <ReceiptIndianRupee size={16} />
                    </div>
                    <span className="font-medium text-gray-900">
                        {row.clientInfo?.billNo || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Price/Paid/Balance",
            key: "Price/Paid/Balance",
            render: (value, row) => {
                return (
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                            <IndianRupee size={16} />
                        </div>
                        <span className="font-medium text-gray-900">
                            {`${row?.billSummary?.grandTotal} / ${row?.billSummary?.payingNow} / ${row?.clientInfo?.unpaidAmt}`}
                        </span>
                    </div>
                );
            }
        },
        {
            title: "Date",
            key: "createdAt",
            render: (value) => {
                console.log("date k liye ", value);
                return (
                    <div className="flex items-center gap-2">
                        <Calendar size={16} className="text-gray-400" />
                        <span className="text-sm text-gray-900">
                            {formatDate(value)}
                        </span>
                    </div>
                )
            }
        },
        {
            title: "Status",
            key: "status",
            render: (value, row) => {
                const status = row.billingStatus ? "Paid" : "Pending";
                const statusColors = {
                    'Paid': 'bg-green-100 text-green-800',
                    'Pending': 'bg-yellow-100 text-yellow-800',
                    'Cancelled': 'bg-red-100 text-red-800'
                };
                return (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColors[status] || 'bg-gray-100 text-gray-800'}`}>
                        {status}
                    </span>
                );
            }
        },
        {
            title: "Actions",
            key: "actions",
            align: "center",
            render: (value, row, index) => (
                <div onClick={(row) => showBill(row, index)} className="cursor-pointer p-1 gap-2 bg-purple-100 rounded-full flex items-center justify-center">
                    <Eye size={16} /><span>view Bill</span>
                </div>
            )
        }
    ];
    const setTabType = (type) => {
        dispatch(setDataAction(null, SET_BILLING__DATA));
        setTab(type)
    }
    const showBill = (row, index) => {
        setBillIndex(index)
        setShowPreview(true);
    }
    return (
        <div className='p-5'>
            <PageHeader
                title={'Billing Management'}
                description={'View and manage billing records'}
            />

            <div className='flex justify-between my-6'>
                <div className="flex ">
                    <div onClick={() => setTabType('Pending')} className='w-20 font-bold border cursor-pointer border-black p-2 rounded-l-lg' style={{ background: tab === 'Pending' ? 'black' : 'white', color: tab === 'Pending' ? 'white' : 'black' }} >
                        <p>Pending</p>
                    </div>
                    <div onClick={() => setTabType('Paid')} className='text-center font-bold w-20 border cursor-pointer border-black p-2 rounded-r-lg ' style={{ background: tab === 'Paid' ? 'black' : 'white', color: tab === 'Paid' ? 'white' : 'black' }}>
                        <p>Paid</p>
                    </div>
                </div>
                <AppButton buttontext="Quick Sale" onClick={() => onClickQuickSell('/quicksale/add')} />
            </div>

            {
                tab === "Pending" ?
                    <div className='mt-6'>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'>
                            {BillingReducer?.billingData?.map((record, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleCardClick(record)}
                                    className='bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden cursor-pointer'
                                >
                                    <div className='bg-gradient-to-r from-blue-500 to-blue-600 p-4 flex justify-center'>
                                        <Armchair color='white' className='w-10 h-10 text-white' />
                                    </div>

                                    <div className='p-5 space-y-3'>
                                        <div className='border-b pb-2'>
                                            <p className='text-xs text-gray-500 uppercase tracking-wide'>Client</p>
                                            <p className='text-lg font-semibold text-gray-800 truncate'>
                                                {Array.isArray(record?.clientInfo) && record.clientInfo[0]?.name
                                                    ? record.clientInfo[0].name
                                                    : 'N/A'}
                                            </p>
                                        </div>
                                        <div className='border-b pb-2'>
                                            <p className='text-xs text-gray-500 uppercase tracking-wide'>Bill Status</p>
                                            <p className='text-lg font-medium text-gray-700'>
                                                {record?.billingStatus ? 'Paid' : 'Unpaid'}
                                            </p>
                                        </div>
                                        {record.clientInfo?.[0]?.unpaidAmt !== undefined && (
                                            <div className=' pt-2'>
                                                <p className='text-xs text-gray-500 uppercase tracking-wide'>Unpaid Amount</p>
                                                <p className='text-sm font-medium text-red-600'>
                                                    ₹{record.clientInfo?.[0].unpaidAmt}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {BillingReducer?.billingData?.length === 0 && (
                            <div className='text-center py-12'>
                                <Armchair className='w-16 h-16 text-gray-300 mx-auto mb-4' />
                                <p className='text-gray-500 text-lg'>No billing records found</p>
                            </div>
                        )}
                    </div>
                    :
                    <div>
                        <AppTable
                            TH={tableHeaders}
                            TD={BillingReducer?.billingData || []}
                            emptyMessage="No billing records found"
                        />
                        <BillPreviewModal
                            isOpen={showPreview}
                            onClose={() => setShowPreview(null)}
                            billData={BillingReducer?.billingData?.[billIndex]}
                        />
                    </div>
            }
        </div>
    );
}

export default BillingSearch;
